import {useRef} from 'react';

import {FloatingList} from '../../_old/styled/internals';

import type {AriaAttributes} from 'react';

// const SPACEBAR_KEY_CODE = [0, 32];
// const ENTER_KEY_CODE = 13;
// const DOWN_ARROW_KEY_CODE = 40;
// const UP_ARROW_KEY_CODE = 38;
// const ESCAPE_KEY_CODE = 27;

type Props = AriaAttributes & {
  collection: [string, string][];
  select: (s: string) => void;
  close: () => void;
};
export function OptionsList({
  select,
  close,
  collection,
  ...props
}: Props): React.JSX.Element {
  const optionsRef = useRef<HTMLUListElement>(null);

  const closeWithBlur = (): void => {
    optionsRef.current?.querySelectorAll('li').forEach((li) => li.blur());
    close();
  };
  const selectWithClose = (v: string): void => {
    select(v);
    closeWithBlur();
  };

  return (
    <FloatingList.List
      role="listbox"
      {...props}
      ref={optionsRef}
      onBlur={closeWithBlur}
    >
      {collection.map((option) => (
        <FloatingList.ListItem
          // onKeyUp={(e) => e.keyCode === ENTER_KEY_CODE && selectWithClose(option[0])}
          key={option[0]}
          id={option[0]}
          role="button"
          tabIndex={0}
          onMouseDown={() => selectWithClose(option[0])}
        >
          {option[1]}
        </FloatingList.ListItem>
      ))}
    </FloatingList.List>
  );
}
